// extracted by mini-css-extract-plugin
module.exports = {"LightBoxContent":"LightBox_LightBoxContent__1fgrW"};